/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildMemoDto } from '../../models/child-memo-dto';

export interface UserChildMemoControllerFindGuardianCounselingMemo$Params {
  childId: string;
  guardianId: string;
  centerId: string;
}

export function userChildMemoControllerFindGuardianCounselingMemo(http: HttpClient, rootUrl: string, params: UserChildMemoControllerFindGuardianCounselingMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChildMemoDto>>> {
  const rb = new RequestBuilder(rootUrl, userChildMemoControllerFindGuardianCounselingMemo.PATH, 'get');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('guardianId', params.guardianId, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChildMemoDto>>;
    })
  );
}

userChildMemoControllerFindGuardianCounselingMemo.PATH = '/api/child-memo/user/guardian-counseling';
